import { DIRECTOR } from 'constants/BroadcastLogViews';
import { ACCEPTED, DENIED } from 'constants/KnockTypes';

export const generateLogPayload = logInfo => {
  const { status, id, meetingId } = logInfo;
  return {
    title: `director ${status} knock. Id: ${id}`,
    view: DIRECTOR,
    'studio.meeting.id': meetingId
  };
};

export const getUpdateKnockLogPayload = (knock, change, meeting) => {
  const { status } = change;
  const { _id } = knock;
  const { attendeeResponse, meetingResponse } = meeting || {};

  const AttendeeId = attendeeResponse?.Attendee?.AttendeeId;
  const MeetingId = meetingResponse?.Meeting?.MeetingId;

  const logInfo = {
    id: _id,
    meetingId: MeetingId,
    attendeeId: AttendeeId
  };

  if (status === DENIED) {
    return generateLogPayload({ ...logInfo, status: 'rejected' });
  }

  if (status === ACCEPTED) {
    return generateLogPayload({ ...logInfo, status: 'approved' });
  }
};

export const getApproveAllKnocksLogPayload = (knockIds, meeting) => {
  const {
    meetingResponse: {
      Meeting: { MeetingId }
    }
  } = meeting;

  return {
    title: `director mass approved knocks. Ids: ${knockIds.join(',')}`,
    view: DIRECTOR,
    'studio.meeting.id': MeetingId
  };
};

const getStreamLogPayload = (user, meeting) => {
  const { _id } = user;
  const {
    attendeeResponse: {
      Attendee: { AttendeeId }
    },
    meetingResponse: {
      Meeting: { MeetingId }
    }
  } = meeting;

  return {
    userId: _id,
    meetingId: MeetingId,
    attendeeId: AttendeeId
  };
};

export const getUserStartedStreamLogPayload = (user, meeting) => {
  const { userId, meetingId } = getStreamLogPayload(user, meeting);
  return {
    title: `Stream started by user Id: ${userId}`,
    view: DIRECTOR,
    'studio.meeting.id': meetingId
  };
};

export const getUserStoppedStreamLogPayload = (user, meeting) => {
  const { userId, meetingId } = getStreamLogPayload(user, meeting);
  return {
    title: `Stream stopped by user Id: ${userId}`,
    view: DIRECTOR,
    'studio.meeting.id': meetingId
  };
};
